import { useTranslation } from "react-i18next";
import ScrollIcon from "../../../icons/scrollIcon";

const CustomDuty = () => {
  const { t } = useTranslation();
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto">
          <span className="block mx-auto w-fit">
            <ScrollIcon className={"size-[60px]"} />
          </span>
          <h1 className="text-[24px] my-5 md:text-[32px] font-bold text-mainBlue text-center">
            {t("customsDutyCalculator")}
          </h1>

          <section className="space-y-8">
            <h2 className="text-xl font-bold text-mainRed">{t("guideToEstimating")}</h2>
            <h3>{t("taxImposedGoods")}</h3>
            <h2 className="text-xl font-bold text-mainRed">{t("howItWorks")}</h2>
            <p>
              <span className="text-mainRed">{t("productValue")}</span>
              {t("theFirstInputIs")}
            </p>
            <p>
              <span className="text-mainRed">{t("customsTariff")}</span>
              {t("eachCountryHasCustomsTariff")}
            </p>
            <p>
              <span className="text-mainRed">{t("shippingAndHandling")}</span>
              {t("costsOfShippingAndHandling")}
            </p>
            <p>
              <span className="text-mainRed">{t("dutyRate")}</span>
              {t("basedOnHSCode")}
            </p>
            <p>
              <span className="text-mainRed">{t("SpecificTaxes")}</span>
              {t("someCountriesImposeTaxes")}
            </p>
          </section>
        </div>
      </article>
    </main>
  );
};

export default CustomDuty;
